import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card ,Empty   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
import ReactExport from "react-export-excel";
import Modaladdcurriculumopen from './Modaladdcurriculumopen';
import Modeltest from './Modeltest';
import Modaladdteacher from './Modaladdteacher';
import Modaladdplan from './Modaladdplan';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { api, URL } from '../../api';
import ModalEditcurriculumopenforuser from './ModalEditcurriculumopenforuser';
import Modaladdteachershow from './Modaladdteachershow';


export default class Curriculum extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          modal: false,
         
          type:'1',
          Approve:'1',

        
          year:'2560',
          search: '',
          searchc: '',

          Course: [],
          Courseselect: [],
          Curriculumopen:[],

          datsShortcourseforuser:[],

          Course_IDs:'',
          Course_ID:'',
          Course_Name_TH:'',
          Course_Name_En:'',
          Course_Credit:'',
          Course_Year:'',
          Course_T_Hour:'',
          Course_Detail_TH:'',
          Course_Detail_EN:'',
          Faculty_ID:'',

          pagination: {
            current: 1,
            pageSize: 20,
          },

        };
       
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

      
        this.time = this.time.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
       
        this.refreshPage = this.refreshPage.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChange2 = this.onChange2.bind(this);


        this.getCurriculumopen = this.getCurriculumopen.bind(this);
        this.updateApprove = this.updateApprove.bind(this);
        this.onChangedelectid = this.onChangedelectid.bind(this);
        this.handleChangecourse = this.handleChangecourse.bind(this);
         this.getcourseforuser = this.getcourseforuser.bind(this);
      
      
      
        
      }


      handleChangecourse(event) {    this.setState({Course_IDs: event.target.value});  }


      onChange(value) {
        
           const Courseselect = this.state.Course.filter( ({ Course_ID }) => Course_ID.substring(0, 7) === value.substring(0, 7) );
         //  const idemp = value;
         //  console.log(Courseselect[0].Course_ID);
           this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
           this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
           this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
           this.setState({ Course_Credit : Courseselect[0].Course_Credit });
           this.setState({ Course_Year : Courseselect[0].Curriculum_Year });
           this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
           this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
           this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });
           this.setState({ Faculty_ID : Courseselect[0].Faculty_ID });

          // this.getCurriculumopen()

        }

        onChange2() {
        
          const Courseselect = this.state.Course.filter( ({ Course_ID }) => Course_ID.substring(0, 7) === this.state.Course_IDs );
        //  const idemp = value;
        //  console.log(Courseselect[0].Course_ID);
          this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
          this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
          this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
          this.setState({ Course_Credit : Courseselect[0].Course_Credit });
          this.setState({ Course_Year : Courseselect[0].Curriculum_Year });
          this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
          this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
          this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });
          this.setState({ Faculty_ID : Courseselect[0].Faculty_ID });

          this.getCurriculumopen()

       }

        //ดึงหลักสูตรที่เปิดสอน
        getCurriculumopen() {
          setTimeout(() => {
             //ภายใน
             api.get('index/getCurriculumopen/'+this.state.Course_ID)
             .then(res => {
             //  console.log(res);
             //  this.setState({ bankname: res.data, loading: false })
          //  const sss = res.data.sort((a, b) => a[Curriculumopen_ID] > b[Curriculumopen_ID] ? -1 : 1)  
          let sortedAsceding = res.data.sort((a, b) => {
            return b.Curriculumopen_ID - a.Curriculumopen_ID;
          });

               this.setState({ Curriculumopen: sortedAsceding})
             }) 
           }, 0);
        }


      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }


      updateApprove(e) {
        // alert('A name was submitted: ' + this.state.value);
      //  console.log(e.target.value)
        const id = e.target.value;
       setTimeout(() => {
    
          const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
          datafrm.append("Curriculumopen_ID", id);
          datafrm.append("Approve", this.state.Approve);
        
          
          api.post("index/updateApprove/",datafrm,{
            headers: {
                'content-type': 'multipart/form-data'
            }
          })
    
          .then(res => {
        //    console.log(res);
            if (res.status === 200) {
            //  alert("บันทึกสำเร็จ")
                      Swal.fire({
                          title: 'ยื่นพิจารณาสำเร็จ',
                          icon: 'success',
                        // showCancelButton: true,
                          confirmButtonText: 'ตกลง',
                        // cancelButtonText: 'No, keep it'
                        }).then((result) => {
                        
                        })
                     }
            })
          //  this.toggle()
          //  this.props.getclassroom()
          this.getCurriculumopen();
     }, 1000);

      }




          getcourseforuser() {
                    api.get('index/getCurriculumopenforuser/'+localStorage.getItem('Citizen_ID'),
                    {headers: {
                        // Authorization: 'Bearer ' + localStorage.getItem('myData')
                    }
                    })
                    .then(res => {
                            console.log(res.data)
                        //   console.log(res.data[0].Studentcb_NAME)
                        //   console.log(ppp)
                        //   const student = res.data.filter( ({ citizen_id }) => citizen_id.substring(0, 7) === this.state.major );
                           const datsShortcourseforuser = res.data;
                         this.setState({ datsShortcourseforuser });
                            // this.setState({   Shortcourse_Nameshortterm_TH:res.data[0].Shortcourse_Nameshortterm_TH,
                            //                 lname:res.data[0].Studentcb_LASTNAME,
                            //                 datedb:res.data[0].Studentcb_DB,
                            //                 Citizen_ID:res.data[0].Studentcb_Citizen_ID
                            //  });
                    })
           }

 

          onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {

            console.log('search:', val);
            this.setState({ searchc: val});
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }




          componentDidMount(){
           

         if (localStorage.getItem('name') == null) {
               
                  window.location.href = 'https://e-student.kpru.ac.th/creditbank'
               
            } else {
        
            }
                    Axios.get(`https://mua.kpru.ac.th/frontend/creditbank/showcourse/2559`,
                  //  Axios.get(`https://git.kpru.ac.th/frontend_tqf/creditbank/showcourse/2559`,
                  //  Axios.get(`https://e-student.kpru.ac.th/e-tqf/Administrator_Course/showlist`,
                      //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                      {headers: {
                        // Authorization: 'Bearer ' + localStorage.getItem('myData')
                      }
                      })
                      //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                      .then(res => {
                         // console.log(res.data[0].id)
                       //  console.log(res.data[0].Course_Detail_TH)
                         const Course = res.data.filter( ({ Curriculum_Year }) => Curriculum_Year >= this.state.year );
                       //  console.log(Course)
                        //  const Course = res.data;
                          this.setState({ Course });
                      })   
                      
                this.getcourseforuser()      
          }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            filterIcon: filtered => (
              <SearchOutlined />
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
        
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };


          onChangedelectid(event) {

            //  console.log(`switch to ${checked}`);
            //  console.log(`switch to ${event.target.value}`);
           const id = event.target.value;

              Swal.fire({
                                title: 'ยืนยันการลบข้อมูล',
                                icon: 'warning',
                               // text: 'กรุณาลองอีกครั้ง',
                              // showCancelButton: true,
                                confirmButtonText: 'ตกลง',
                             //  cancelButtonText: 'No, keep it'
                              }).then((result) => {
                                console.log(`switch to 888`);

                                              setTimeout(() => {
                                                const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                                datafrm.append("Curriculumopen_ID", id);
                                                api.post("index/deleteculiculum/",datafrm,{
                                                  headers: {
                                                      'content-type': 'multipart/form-data'
                                                  }
                                                })
                                          
                                                .then(res => {
                                              //    console.log(res);
                                                  if (res.status === 200) {
                                                  //  alert("บันทึกสำเร็จ")
                                                            Swal.fire({
                                                                title: 'ลบข้อมูลสำเร็จ',
                                                                icon: 'success',
                                                              // showCancelButton: true,
                                                                confirmButtonText: 'ตกลง',
                                                              // cancelButtonText: 'No, keep it'
                                                              }).then((result) => {
                                                              
                                                              })
                                                          }
                                                  })
                                                //  this.toggle()
                                                //  this.props.getclassroom()
                                                this.getCurriculumopen();
                                          }, 1000);



                              })

                              


            //   const datafrm = new FormData(); 
            //   if (checked === true) {
            //     datafrm.append("Curriculumopen_Status_ONOFF", '1') ;
            //   }else{
            //     datafrm.append("Curriculumopen_Status_ONOFF", '0') ;
            //   }
            //   datafrm.append("Curriculumopen_ID", event.target.value);
            
            //  // console.log(datafrm);
            //  api.post("index/updateCurriculumonoff/",datafrm,{
            //       headers: {
            //           'content-type': 'multipart/form-data'
            //       }
            //   })
            //   .then(res => {
            //         if (checked === true) {
            //            Swal.fire({
            //                 title: 'เปิดหลักสูตรสำเร็จ',
            //                 icon: 'success',
            //                // text: 'กรุณาลองอีกครั้ง',
            //               // showCancelButton: true,
            //                 confirmButtonText: 'ตกลง',
            //               // cancelButtonText: 'No, keep it'
            //               }).then((result) => {
                          
            //               })
            //         } else {
            //           Swal.fire({
            //             title: 'ปิดหลักสูตรสำเร็จ',
            //             icon: 'success',
            //            // text: 'กรุณาลองอีกครั้ง',
            //           // showCancelButton: true,
            //             confirmButtonText: 'ตกลง',
            //           // cancelButtonText: 'No, keep it'
            //           }).then((result) => {
                      
            //           })
                      
            //         }   
            //   }) 
             }

    render() {

 //       console.log(this.state.Course_ID)
      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
        const {  pagination } = this.state;
     
        const { Option } = Select;

               //ชุดค้นหา2 นำ filteredPage ไป this.state
               let filteredPage = this.state.Course.filter(
                (Course) => {
                  return (Course.Course_ID.indexOf(this.state.searchc) !== -1) 
                }
              )
            //ชุดค้นหานำ2 filteredPage ไป this.state
       

       
        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางเรียน </h4>
                </MDBAlert>
                <br/> */}
    
{/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
       <Card type="inner" style={{ marginTop: 0 }} headStyle={{ backgroundColor: '#dfdcdcff', color: '#ffffff' }}  title={<h4><MDBIcon icon="list-alt" /> จัดการหลักสูตร/เพิ่มหลักสูตร</h4> } extra={<a href="#"><p>คุณ{localStorage.getItem('name')}</p></a>} >

       <MDBRow>
            <MDBCol sm="4">
            <label htmlFor="example2"><MDBIcon icon="search" />  ค้นหารหัสรายวิชาหลัก </label><br/>
                <Select
                    showSearch
                    style={{ width: 400 }}
                    placeholder="เลือกรหัสวิชา"
                    optionFilterProp="children"
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                   {filteredPage.map((Course,index )  => 
                   <option value={Course.Course_ID}>{Course.Course_ID + Course.Course_Name_TH + ' (ปี '+Course.Curriculum_Year+')'}</option>
                   )}
                  </Select>

                          {/* <Select
                              showSearch
                              style={{ width: 400 }}
                              placeholder="Search to Select"
                              optionFilterProp="children"
                              onChange={this.onChange}
                              filterOption={(input, option) => (option?.value ?? '').includes(input)}
                              filterSort={(optionA, optionB) =>
                                (optionA?.value ?? '').toLowerCase().localeCompare((optionB?.value ?? '').toLowerCase())
                              }
                            
                              options={(this.state.Course || []).map((d) => ({
                                value: d.Course_ID,
                                label: d.Course_ID+ "" +d.Course_Name_TH,
                              }))}
                            /> */}


                {/* <div className="form-group">
                    <label htmlFor="example2">รหัสวิชา</label>
                    <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_IDs} onChange={this.handleChangecourse}  />
                </div> */}

   {/* <MDBBtn color="primary" onClick={this.onChange2} >ค้นหา</MDBBtn>  */}


            </MDBCol>

            <MDBCol sm="4">
                 <div>
                 {/* <Modeltest/> */}
                 </div>
                    {/* <br/> */}
            </MDBCol> 
  </MDBRow>

<br/>
    <MDBRow>
                <MDBCol sm="12">
                    {this.state.Course_ID != '' ? <>
                      <MDBJumbotron fluid>
                        <MDBContainer>
                        <h2 className="display-5 deep-purple-text text-center">รายวิชา {this.state.Course_Name_TH}</h2>
                            <h4 className="display-5 deep-purple-text">รายละเอียดวิชา</h4>
                            {/* <p className="lead">This is a modified jumbotron that occupies the entire horizontal space of its parent.</p> */}
                            <MDBTable bordered responsiveMd>
                            <MDBTableHead color="primary-color" textWhite>
                              <tr>
                                <th>รหัสวิชา</th>
                                <th>ชื่อวิชาภาษาไทย</th>
                                <th>ชื่อวิชาภาษาอังกฤษ</th>
                                <th>หน่วยกิต</th>
                                <th>ปี</th>
                                <th>จำนวนชั่วโมง</th>
                                <th>คำอธิบายรายวิชาภาษาไทย</th>
                                <th>คำอธิบายรายวิชาภาษาอังกฤษ</th>
                              </tr>
                            </MDBTableHead>
                            <MDBTableBody>

                                <tr>
                                <td>{this.state.Course_ID}</td>
                                <td>{this.state.Course_Name_TH}</td>
                                <td>{this.state.Course_Name_En}</td>
                                <td>{this.state.Course_Credit}</td>
                                <td>{this.state.Course_Year}</td>
                                <td>{this.state.Course_T_Hour}</td>
                                <td>{this.state.Course_Detail_TH}</td>
                                <td>{this.state.Course_Detail_EN}</td>
                                </tr>

                            </MDBTableBody>
                            </MDBTable>
                            <div className='text-center'><Modaladdcurriculumopen Course_ID={this.state.Course_ID} Course_YEAR={this.state.Course_Year} Faculty_ID={this.state.Faculty_ID} /></div>  
                        </MDBContainer>
                        </MDBJumbotron>
                    </>:<></>}
              
               
                </MDBCol>

                {/* <MDBCol sm="7">
              
                </MDBCol>  */}
    </MDBRow>

     <MDBRow>
          <MDBCol sm="12">
          {/* {this.state.Course_ID != '' ? <> */}
                      <MDBJumbotron fluid>
                        <MDBContainer fluid>
                            {/* <h4 className="display-5 deep-purple-tex text-center">ข้อมูลรายวิชา {this.state.Course_Name_TH}</h4> */}
                              <h2 className="display-5 deep-purple-text text-center">ประวัติข้อมูลหลักสูตร</h2>
                            {/* <Modaladdcurriculumopen Course_ID={this.state.Course_ID} Course_YEAR={this.state.Course_Year} Faculty_ID={this.state.Faculty_ID} /> */}
                            
                            {/* <p className="lead">This is a modified jumbotron that occupies the entire horizontal space of its parent.</p> */}
                            {/* <Table id="pdfdiv" columns={columns} dataSource={this.state.Curriculumopen} onChange={this.handleChange} responsive scroll={{ x: 1000 }}  pagination={{ pagination, showSizeChanger: true}}   />     */}
                          {this.state.datsShortcourseforuser.length != 0 ?<> 
                          <hr/>
                           <MDBTable small responsiveMd>
                                <MDBTableHead color="grey darken-1" textWhite>
                                    <tr>
                                    <th>ลำดับ</th>
                                    <th>ปี</th>
                                    <th>เทอม</th>
                                    <th>ชื่อหลักสูตรภาษาไทย</th>
                                    <th>ชื่อหลักสูตรภาษาอังกฤษ</th>
                                    <th>จำนวนชั่วโมง</th>
                                    <th>จำนวนที่รับ</th>
                                    {/* <th>วันเริ่ม</th>
                                    <th>วันสิ้นสุด</th> */}
                                    <th>วันเริ่ม</th>
                                    <th>วันสิ้นสุด</th>
                                    <th>จัดการผู้สอน/วิทยากร</th>
                                    <th>จัดการแผนการเรียน</th>
                                    <th>การพิจารณา</th>
                                    <th>หลักสูตร</th>
                                    <th>คณบดี</th>
                                    {/* <th>จัดการ</th> */}
                                    </tr>
                                </MDBTableHead>

                                <MDBTableBody>
                                {this.state.datsShortcourseforuser.map((Curriculumopen,index) => {
                                  return  <tr>
                                    <td>{index+1}</td>
                                    <td>{Curriculumopen.Course_YEAR }</td>
                                    <td>{Curriculumopen.Curriculumopen_TEAM }</td>
                                    <td>{Curriculumopen.Curriculumopen_Full_Name_TH }</td>
                                    <td>{Curriculumopen.Curriculumopen_Full_Name_EN }</td>
                                    <td>{Curriculumopen.Curriculumopen_CH }</td>
                                    <td>{Curriculumopen.Curriculumopen_NUM }</td>
                                    {/* <td>{Curriculumopen.Curriculumopen_Date_STARTRE }</td>
                                    <td>{Curriculumopen.Curriculumopen_Date_ENDRE }</td> */}
                                    <td>{Curriculumopen.Curriculumopen_Date_START }</td>
                                    <td>{Curriculumopen.Curriculumopen_Date_END }</td>
                                    <td>
                                    {Curriculumopen.Curriculumopen_Approve_Dean === '2' &&  Curriculumopen.Curriculumopen_Approve_Cu === '2'  ? <><Modaladdteachershow  Curriculumopen_ID={Curriculumopen.Curriculumopen_ID } Curriculumopen_Full_Name_TH={Curriculumopen.Curriculumopen_Full_Name_TH} Univ_ID={Curriculumopen.Univ_ID} Curriculumopen_Approve_Cu={Curriculumopen.Curriculumopen_Approve_Cu} />
                                    {/* <MDBBtn color="dark-green" size="sm">แสดงผู้สอน</MDBBtn> */}
                                    </>:<> 
                                    <Modaladdteacher Curriculumopen_ID={Curriculumopen.Curriculumopen_ID } Curriculumopen_Full_Name_TH={Curriculumopen.Curriculumopen_Full_Name_TH} Univ_ID={Curriculumopen.Univ_ID} Curriculumopen_Approve_Cu={Curriculumopen.Curriculumopen_Approve_Cu} />
                                    </>}
                                     
                                      </td>
                                    <td>
                                    {Curriculumopen.Curriculumopen_Approve_Dean === '2' &&  Curriculumopen.Curriculumopen_Approve_Cu === '2'  ? <>
                                    {/* <MDBBtn color="info" size="sm">เพิ่มแผนการสอน</MDBBtn> */}
                                    <Modaladdplan Curriculumopen_ID={Curriculumopen.Curriculumopen_ID } Curriculumopen_Full_Name_TH={Curriculumopen.Curriculumopen_Full_Name_TH} Univ_ID={Curriculumopen.Univ_ID} Course_YEAR={Curriculumopen.Course_YEAR } Curriculumopen_TEAM={Curriculumopen.Curriculumopen_TEAM } Curriculumopen_Approve_Cu={Curriculumopen.Curriculumopen_Approve_Cu}/>
                                    </>:<>
                                     <Modaladdplan Curriculumopen_ID={Curriculumopen.Curriculumopen_ID } Curriculumopen_Full_Name_TH={Curriculumopen.Curriculumopen_Full_Name_TH} Univ_ID={Curriculumopen.Univ_ID} Course_YEAR={Curriculumopen.Course_YEAR } Curriculumopen_TEAM={Curriculumopen.Curriculumopen_TEAM }/>
                                     </>}
                                     </td>
                                    <td className="text-center">
                                      {Curriculumopen.Curriculumopen_Approve_Cu === '' || Curriculumopen.Curriculumopen_Approve_Cu === null ?<> <MDBBtn color="deep-orange" size="sm" value={Curriculumopen.Curriculumopen_ID}  onClick={this.updateApprove}>ยื่นพิจารณา</MDBBtn> <ModalEditcurriculumopenforuser Curriculumopen_ID={Curriculumopen.Curriculumopen_ID}  getCurriculumopen={ this.getCurriculumopen} /></>: 
                                      <> ยื่นพิจารณาแล้ว </> }
                                     

                                      {/* {Curriculumopen.Curriculumopen_Approve_Cu != null || Curriculumopen.Curriculumopen_Approve_Cu === '1' && Curriculumopen.Curriculumopen_Approve_Cu != '3' && Curriculumopen.Curriculumopen_Approve_Dean != '3' ?<> 
                                                      {Curriculumopen.Curriculumopen_Approve_Cu === '3' || Curriculumopen.Curriculumopen_Approve_Dean === '3' ?<>

                                                              {Curriculumopen.Curriculumopen_Approve_Cu === '3' ?<> <MDBAlert color="danger " > หลักสูตรไม่อนุมัติ </MDBAlert><MDBAlert color="primary  " > ข้อเสนอแนะ : {Curriculumopen.Curriculumopen_comment_Cu}</MDBAlert><MDBBtn color="amber" size="sm"  value={Curriculumopen.Curriculumopen_ID}  onClick={this.updateApprove}>ยื่นพิจารณาอีกครั้ง</MDBBtn></>: <>  </> }
                                                              {Curriculumopen.Curriculumopen_Approve_Dean === '3' && Curriculumopen.Curriculumopen_Approve_Cu != '1'   ?<> <MDBAlert color="danger " > คณบดีไม่อนุมัติ </MDBAlert><MDBAlert color="primary  " > ข้อเสนอแนะ : {Curriculumopen.Curriculumopen_comment_Dean}</MDBAlert><MDBBtn color="amber" size="sm"  value={Curriculumopen.Curriculumopen_ID}  onClick={this.updateApprove}>ยื่นพิจารณาอีกครั้ง</MDBBtn></>: <>  </> }
                                                              {Curriculumopen.Curriculumopen_Approve_Dean === '3' && Curriculumopen.Curriculumopen_Approve_Cu === '1' ?<>
                                                              <MDBTable bordered>
                                                              <MDBTableHead>
                                                                <tr>
                                                                  <th className="text-center">หลักสูตร</th>
                                                                  <th className="text-center">คณบดี</th>
                                                                </tr>
                                                              </MDBTableHead>
                                                              <MDBTableBody>
                                                                <tr>
                                                                  <td className="text-center">
                                                                    
                                                                    {Curriculumopen.Curriculumopen_Approve_Cu === '1'?<><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                                                    {Curriculumopen.Curriculumopen_Approve_Cu === '2'?<> <MDBIcon icon="check"  className="green-text pr-3" />อนุมัติ</>:<></>}
                                                                    
                                                                  </td>
                                                                  <td className="text-center">
                                                                    {Curriculumopen.Curriculumopen_Approve_Cu === '1' || Curriculumopen.Curriculumopen_Approve_Dean === null ?<><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                                                    {Curriculumopen.Curriculumopen_Approve_Dean === '' || Curriculumopen.Curriculumopen_Approve_Dean === null ?<><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                                                    {Curriculumopen.Curriculumopen_Approve_Dean === '2'?<> <MDBIcon icon="check"  className="green-text pr-3" />อนุมัติ</>:<> </>}
                                                                  </td>
                                                                </tr> 
                                                              </MDBTableBody>
                                                            </MDBTable>

                                                               </>: <>  </> }
                                                       </>:<>
                                                       
                                                          <MDBTable bordered>
                                                              <MDBTableHead>
                                                                <tr>
                                                                  <th className="text-center">หลักสูตร</th>
                                                                  <th className="text-center">คณบดี</th>
                                                                </tr>
                                                              </MDBTableHead>
                                                              <MDBTableBody>
                                                                <tr>
                                                                  <td className="text-center">
                                                                    
                                                                    {Curriculumopen.Curriculumopen_Approve_Cu === '1'?<><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                                                    {Curriculumopen.Curriculumopen_Approve_Cu === '2'?<> <MDBIcon icon="check"  className="green-text pr-3" />อนุมัติ</>:<></>}
                                                                    
                                                                  </td>
                                                                  <td className="text-center">
                                                                    {Curriculumopen.Curriculumopen_Approve_Dean === '' || Curriculumopen.Curriculumopen_Approve_Dean === null ?<><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                                                    {Curriculumopen.Curriculumopen_Approve_Dean === '2'?<> <MDBIcon icon="check"  className="green-text pr-3" />อนุมัติ</>:<> </>}
                                                                  </td>
                                                                </tr> 
                                                              </MDBTableBody>
                                                            </MDBTable>
                                                    </>}
                                     
                                      </>: <> 
                                      {Curriculumopen.Curriculumopen_Approve_Cu === '3' ?<> <MDBAlert color="danger " > หลักสูตรไม่อนุมัติ </MDBAlert><MDBAlert color="primary  " > ข้อเสนอแนะ : {Curriculumopen.Curriculumopen_comment_Cu}</MDBAlert><MDBBtn color="amber" size="sm"  value={Curriculumopen.Curriculumopen_ID}  onClick={this.updateApprove}>ยื่นพิจารณาอีกครั้ง</MDBBtn></>: <>  </> }
                                      {Curriculumopen.Curriculumopen_Approve_Dean === '3' && Curriculumopen.Curriculumopen_Approve_Cu != '1' ?<> <MDBAlert color="danger " > คณบดีไม่อนุมัติ </MDBAlert><MDBAlert color="primary  " > ข้อเสนอแนะ : {Curriculumopen.Curriculumopen_comment_Dean}</MDBAlert><MDBBtn color="amber" size="sm"  value={Curriculumopen.Curriculumopen_ID}  onClick={this.updateApprove}>ยื่นพิจารณาอีกครั้ง</MDBBtn></>: <>  </> }
                                     
                                      </> } */}

                                    </td>
                                    <td>
                                      {Curriculumopen.Curriculumopen_Approve_Cu === '1' ? <><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                      {Curriculumopen.Curriculumopen_Approve_Cu === '2' ? <><MDBIcon icon="check"  className="green-text pr-3" />อนุมัติ</>:<></>}
                                      {Curriculumopen.Curriculumopen_Approve_Cu === '3' ? <><MDBAlert color="danger " > หลักสูตรไม่อนุมัติ </MDBAlert><MDBAlert color="primary  " > ข้อเสนอแนะ : {Curriculumopen.Curriculumopen_comment_Cu}</MDBAlert><MDBBtn color="amber" size="sm"  value={Curriculumopen.Curriculumopen_ID}  onClick={this.updateApprove}>ยื่นพิจารณาอีกครั้ง</MDBBtn></>:<></>}
                                    
                                    </td>


                                    <td>
                                      {Curriculumopen.Curriculumopen_Approve_Dean === null   &&  Curriculumopen.Curriculumopen_Approve_Cu === '2'  ? <><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                      {Curriculumopen.Curriculumopen_Approve_Dean === '2' &&  Curriculumopen.Curriculumopen_Approve_Cu === '2'  ? <><MDBIcon icon="check"  className="green-text pr-3" />อนุมัติ</>:<></>}
                                      {Curriculumopen.Curriculumopen_Approve_Dean === '3' && Curriculumopen.Curriculumopen_Approve_Cu === '2' ? <><MDBAlert color="danger " > คณบดีไม่อนุมัติ </MDBAlert><MDBAlert color="primary  " > ข้อเสนอแนะ : {Curriculumopen.Curriculumopen_comment_Dean}</MDBAlert><MDBBtn color="amber" size="sm"  value={Curriculumopen.Curriculumopen_ID}  onClick={this.updateApprove}>ยื่นพิจารณาอีกครั้ง</MDBBtn></>:<></>}
                                      {Curriculumopen.Curriculumopen_Approve_Dean === '3' &&  Curriculumopen.Curriculumopen_Approve_Cu === '1'  ? <><MDBIcon icon="sync-alt" /> อยู่ระหว่างพิจารณา</>:<></>}
                                    </td>

                                    {/* <td> <MDBBtn color="unique" size="sm" value={Curriculumopen.Curriculumopen_ID} onClick={this.onChangedelectid}  >ลบ</MDBBtn></td> */}

                                    </tr>
                                   })}  
                                </MDBTableBody>
                            </MDBTable>   
                           </>:<> 
                           <hr/>
                           <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                           
                            </> }
                           
                           

                        </MDBContainer>
                        </MDBJumbotron>
                    {/* </>:<></>}        */}
          </MDBCol>
     </MDBRow>

        </Card>

       
            </MDBContainer>
        )
    }
}
